<template>
  <EmdFormGroup
    :label="$t('site-url')"
    :state="getState($v.site_url)"
    :feedbacks="feedbacks($v.site_url)"
  >
    <EmdInput
      @input="() => $v.site_url.$touch()"
      v-model="recipient.site_url"
      name="site_url"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { recipientValidationsGeneral } from '../validations'
export default {
  name: 'SiteUrlInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    site_url: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return recipientValidationsGeneral
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "site-url": "Site do recebedor"
    },
    "en-US": {
      "site-url": "Recipient site"
    }
  }
</i18n>
